import {
  type TableSearchProviderProps,
  useSearchParamsApi,
} from "./TableSearchContext";
import { TableSearchProviderValue } from "./TableSearchProviderValue";

export function TableSearchParamsBackend(props: TableSearchProviderProps) {
  const value = useSearchParamsApi({
    defaultPageSize: props.defaultPageSize,
    searchDebounceMs: props.searchDebounceMs,
  });

  return (
    <TableSearchProviderValue value={value}>
      {props.children}
    </TableSearchProviderValue>
  );
}
